import { render, staticRenderFns } from "./About1024.vue?vue&type=template&id=ab30e460&scoped=true"
import script from "./About1024.vue?vue&type=script&lang=js"
export * from "./About1024.vue?vue&type=script&lang=js"
import style0 from "./About1024.vue?vue&type=style&index=0&id=ab30e460&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab30e460",
  null
  
)

export default component.exports